import React from 'react';
import { useDigitsSum } from '../../hooks/useDigitsSum';
import CodeBlock from '../ui/CodeBlock';
import ResultBox from '../ui/ResultBox';
import TestCase from '../ui/TestCase';
import styles from './Exercise.module.css';

const CODE = `<span class="token-kw">function</span> <span class="token-fn">digitsSum</span>(inputInt) {
  <span class="token-kw">let</span> sum = <span class="token-num">0</span>;

  <span class="token-cm">// % 10 extrae el último dígito: 123 % 10 = 3</span>
  <span class="token-cm">// Math.floor elimina ese dígito: floor(123/10) = 12</span>
  <span class="token-kw">while</span> (inputInt <span class="token-op">&gt;</span> <span class="token-num">0</span>) {
    sum <span class="token-op">+=</span> inputInt <span class="token-op">%</span> <span class="token-num">10</span>;
    inputInt <span class="token-op">=</span> Math.floor(inputInt <span class="token-op">/</span> <span class="token-num">10</span>);
  }

  <span class="token-kw">return</span> sum;
}`;

function DigitsSumExercise() {
  const { input, handleChange, result, isValid, testResults } = useDigitsSum();

  const resultVariant = isValid ? 'ok' : 'neutral';
  const resultValue = isValid
    ? `digitsSum(${input}) = ${result}`
    : null;

  return (
    <div className={styles.exercise}>
      <div className={styles.split}>
        {/* Columna izquierda: código */}
        <div className={styles.codeCol}>
          <p className={styles.colLabel}>Implementación</p>
          <CodeBlock code={CODE} />
        </div>

        {/* Columna derecha: playground */}
        <div className={styles.playCol}>
          <p className={styles.colLabel}>Prueba</p>

          <div className={styles.field}>
            <label className={styles.inputLabel} htmlFor="ds-input">
              Entero positivo
            </label>
            <input
              id="ds-input"
              className={styles.input}
              type="number"
              min="0"
              placeholder="Ej: 12345"
              value={input}
              onChange={(e) => handleChange(e.target.value)}
            />
            <span className={styles.hint}>Escribe cualquier entero ≥ 0</span>
          </div>

          <ResultBox
            label="Resultado"
            value={resultValue}
            variant={resultVariant}
          />
        </div>
      </div>

      {/* Casos de prueba */}
      <div className={styles.tests}>
        <p className={styles.testsLabel}>Casos de prueba del enunciado</p>
        <div className={styles.testsList}>
          {testResults.map((tc) => (
            <TestCase
              key={tc.input}
              inputLabel={`digitsSum(${tc.input})`}
              expectedLabel={String(tc.expected)}
              actualLabel={String(tc.actual)}
              pass={tc.pass}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default DigitsSumExercise;
